import { get } from '~/utils/adapi';

const SET_CONFIG = 'SET_CONFIG';
const SET_LOADING = 'SET_LOADING';

const actions = {
  updateConfig({ commit, state }) {
    // There is no need to get new config every time.
    if (state.config) {
      return Promise.resolve();
    }

    commit(SET_LOADING, true);
    return get('config/generic')
      .then(config => {
        commit(SET_CONFIG, { config, error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_CONFIG, { error, config: {} });
        commit(SET_LOADING, false);
      });
  },
};

const mutations = {
  [SET_CONFIG](state, { config, error }) {
    state.config = config;
    state.error = error;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state: {
    config: null,
    error: null,
    loading: false,
  },
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/modules/genericConfig.js